module.exports = __webpack_public_path__ + "static/media/arrow-square-down.53b28517.svg";